var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagVietnam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagVietnam_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagVietnam_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagVietnam_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagVietnam_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagVietnam_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8172B",
    d: "M-11 44.122h70.482V3H-11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFF2C",
    d: "M29.22 26.477l3.077 9.476-8.056-5.857-8.056 5.857 3.077-9.476-8.056-5.848h9.958l3.077-9.475 3.085 9.475h9.95z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iaHlza2szMDJlYSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJ6ZnYwaGZ3aW9iIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2h5c2trMzAyZWEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiNoeXNrazMwMmVhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjemZ2MGhmd2lvYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0M4MTcyQiIgZD0iTTAgNDEuMTIyTDcwLjQ4MiA0MS4xMjIgNzAuNDgyIDAgMCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExIDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0ZDRkYyQyIgZD0iTTQwLjIyIDIzLjQ3N0w0My4yOTcgMzIuOTUzIDM1LjI0MSAyNy4wOTYgMjcuMTg1IDMyLjk1MyAzMC4yNjIgMjMuNDc3IDIyLjIwNiAxNy42MjkgMzIuMTY0IDE3LjYyOSAzNS4yNDEgOC4xNTQgMzguMzI2IDE3LjYyOSA0OC4yNzYgMTcuNjI5eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExIDMpIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgFlagVietnam as ReactComponent };